module.exports = __webpack_public_path__ + "img/Badge.b0d6e874.svg";